/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = {
  ATTRIBUTE: 1,
  CHILD: 2,
  PROPERTY: 3,
  BOOLEAN_ATTRIBUTE: 4,
  EVENT: 5,
  ELEMENT: 6
},
      i = t => (...i) => ({
  _$litDirective$: t,
  values: i
});

class s {
  constructor(t) {}

  T(t, i, s) {
    this.Σdt = t, this.M = i, this.Σct = s;
  }

  S(t, i) {
    return this.update(t, i);
  }

  update(t, i) {
    return this.render(...i);
  }

}

export { i, s, t };
